var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLabTest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    opacity: 0.6,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-51.2 -51.2 614.40 614.40",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9E3F7"
    },
    d: "M170.667,34.133v392.533C170.667,473.795,208.872,512,256,512s85.333-38.205,85.333-85.333V34.133 H170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M341.333,426.667V301.312c-28.974-11.329-39.84-35.072-85.333-35.072s-56.359,23.743-85.333,35.072 v125.355C170.667,473.795,208.872,512,256,512S341.333,473.795,341.333,426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2001D"
    },
    d: "M341.333,426.667V301.312c-28.974-11.329-39.84-35.072-85.333-35.072c0,32.427,0,206.507,0,245.76 C303.128,512,341.333,473.795,341.333,426.667z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.533,
    style: {
      fill: "#AED5F3"
    },
    width: 238.933,
    height: 68.267
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    style: {
      fill: "#93C7EF"
    },
    width: 119.467,
    height: 68.267
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 238.933,
    cy: 187.733,
    r: 34.133
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A2001D"
    },
    cx: 290.133,
    cy: 119.467,
    r: 17.067
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D80027"
    },
    cx: 298.667,
    cy: 366.933,
    r: 25.6
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A2001D"
    },
    cx: 221.867,
    cy: 426.667,
    r: 17.067
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTest);
export default __webpack_public_path__ + "static/media/labTest.682e59f41f208844a7227eaecb99ff6c.svg";
export { ForwardRef as ReactComponent };